import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row } from 'react-bootstrap';
const Moment = require('moment');
const uuid = require('uuid');
import { withRouter, Link } from 'react-router-dom';
const filter = require('lodash/filter');
const some = require('lodash/some');
const find = require('lodash/find');

const Globals = require('../../../app/globals');
const ServerRequest = require('../actions/request');
const SignInStore = require('../stores/SignInStore');
const ChannelStore = require('../stores/channel_store_reflux');
const SubscriptionPlanStore = require('../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../actions/SubscriptionPlanActions');
const StringUtil = require('../../../app/shared/StringUtil');
import Navigator from '../Navigator';
import MainNav from './DashboardNew/Menu/MainNav';
import SubNav from './nav/SubNav';
import ConfirmModal from './modal/ConfirmModal';
// const SubscriptionSettingsModal = require('./modal/SubscriptionSettingsModal');
import BackButton from './nav/BackButton';
import LoadingMainContent from './loading/LoadingMainContent';
import ErrorBox from './common/ErrorBox';
import WarningBox from './common/WarningBox';
import RegisterOrganization from './common/RegisterOrganization';
import AccountInfoEdit from './account/AccountInfoEdit';
import AccountSettingsEdit from './account/AccountSettingsEdit';
import SortableTable2 from './table/SortableTable2';
import Tooltip from './common/Tooltip';

const propTypes = {
    history: PropTypes.object.isRequired,
};
const defaultProps = {};

class AccountSettings extends React.Component {
    constructor(props) {
        super(props);
        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        const planStoreState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState());
        this.state = {
            signInStoreState: SignInStore.getState(),
            channelStoreState: ChannelStore.getState(),
            hasError: false,
            saveEnabled: false,
            showRegisterOrgModal: false,
            showSubscriptionSettingsModal: false,
            showCancelSubscriptionModal: false,
            // showDeleteAccountModal: false,
            // showOrgSubscriptionSettingsModal: false,
            // showPayForOrgModal: false,
            upgrade_error: null,
            upgrade_plan_id: '',
            upgrading: false,

            selectedOrg: null,
            buy_org_error: null,
            buying_org: false,
            updateInfoActionId: null,
            cancelActionId: null,
            subscriptionError: null,
            ...planStoreState
        };
        this.backHandler = this.backHandler.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.gotoPasswordSettings = this.gotoPasswordSettings.bind(this);
        this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
        this.refreshUserInfo = this.refreshUserInfo.bind(this);
        this.openRegisterOrgPanel = this.openRegisterOrgPanel.bind(this);
        this.closeRegisterOrgPanel = this.closeRegisterOrgPanel.bind(this);
        this.selectOrgPlan = this.selectOrgPlan.bind(this);
        this.handleCancelSubscriptionPromise = this.handleCancelSubscriptionPromise.bind(this);
        this.renderRegisterOrgModal = this.renderRegisterOrgModal.bind(this);
        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreStateChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreStateChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        this.refreshUserInfo();
    }

    componentWillUnmount() {
        if (this.handlerCleanup) {
            this.handlerCleanup();
            delete this.handlerCleanup;
        }

        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreStateChange(newState) {
        this.setState({ signInStoreState: newState });
    }

    onChannelStoreStateChange(newState) {
        this.setState({ channelStoreState: newState });
    }

    getStateFromPlanStoreState(state) {
        const user_plans = filter(state.upgrade_plans, (plan) => {
            return Globals.users.is_user_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        const org_plans = filter(state.upgrade_plans, (plan) => {
            return Globals.users.is_org_account_type(plan.account_type) && ( plan.process_type === Globals.ecommerce.process_types.CC);
        });

        return {
            user_plans: user_plans,
            org_plans: org_plans,
            plan_prorate_data: state.plan_prorate_data,
            subscription_plan: state.subscription_plan,
            owned_org_subscriptions: state.owned_org_subscriptions,
        };
    }

    onSubscriptionPlanStoreChange(state) {
        const planStoreState = this.getStateFromPlanStoreState(state);
        let additionalState = {};
        if (state.action.id === this.state.cancelActionId) {
            if (!state.action.error) {
                // cancellation success state.
                additionalState = { ...additionalState, cancelActionId: null };
            }
            else {
                additionalState = { ...additionalState, cancelActionId: null, subscriptionError: state.action.error };
            }
        }

        this.setState({ showCancelSubscriptionModal: false, ...planStoreState, ...additionalState });
    }

    backHandler(){
        Navigator.goToDashboardHome(this.props.history);
    }

    showModal(stateProp) {
        this.setState({ [stateProp]: true });
    }

    hideModal(stateProp) {
        this.setState({ [stateProp]: false });
    }

    gotoPasswordSettings(){
        //todo
    }

    handleDeleteAccount(){
        //todo
    }

    refreshUserInfo() {
        SignInStore.getUserInfo();

        var actionId = uuid.v4();
        SubscriptionPlanActions.getUpgradePlans(actionId);

        var otherActionId = uuid.v4();
        SubscriptionPlanActions.getSubscriptionPlan(otherActionId);

        var actionId3 = uuid.v4();
        SubscriptionPlanActions.getOwnedOrgSubscriptions(actionId3);

        var actionId4 = uuid.v4();
        SubscriptionPlanActions.getProrateData(actionId4);
    }

    openRegisterOrgPanel(e) {
        if ((!this.state.org_plans) || (!this.state.org_plans.length)) {
            return;
        }

        let org_plan_id = '';
        if (this.state.org_plans.length === 1) {
            org_plan_id = this.state.org_plans[0].id;
        }

        this.setState({
            buy_org_error: null,
            org_plan_id: org_plan_id,
            showRegisterOrgModal: true,
        });
    }

    closeRegisterOrgPanel() {
        if (this.handlerCleanup) {
            this.handlerCleanup();
            delete this.handlerCleanup;
        }

        this.setState({
            buy_org_error: '',
            buying_org: false,
            showRegisterOrgModal: false,
        });
    }

    selectOrgPlan(value) {
        this.setState({ org_plan_id: value });
    }

    // handleChangeSubscriptionPromise(plan_id,token_id, proration_date) {
    //     // cost is the cost we told the user. It should match the upgrade cost
    //     return ServerRequest.makeRequest('/authoring/ecommerce/upgrade_account', 'POST', JSON.stringify({
    //         plan_id: plan_id,
    //         token_id: token_id,
    //         proration_date: proration_date, // Supply this so that what we tell the user matches what stripe calculates
    //     }));
    // }

    handleCancelSubscriptionPromise() {
        const actionId = uuid.v4();
        this.setState({ cancelActionId: actionId }, () => {
            return SubscriptionPlanActions.cancelSubscription(actionId, { subscription_id: this.state.subscription_plan.plan.subscription_id });
        });
    }

    renderRegisterOrgModal() {
        let canCancel = true;
        if (this.state.buying_org) {
            canCancel = false;
        }

        // TODO: we should be asking for payment here
        return (
            <Modal
                show
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeRegisterOrgPanel}
            >
                <Modal.Header onHide={this.closeRegisterOrgPanel}>
                    <Modal.Title>Register Organization</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <RegisterOrganization
                        className="buy-organization-description"
                        defaultOwnerEmail={this.state.signInStoreState.userInfo.email}
                        showOwnerEmail={false}
                        completeCallback={this.closeRegisterOrgPanel /*TODO: some way verify that the organization has been added*/}
                        payMethodTypes={[Globals.ecommerce.process_types.CC]}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant='info' disabled={!canCancel}  onClick={this.closeRegisterOrgPanel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        if (!this.state.signInStoreState.initialized) {
            return (
                <div>
                    <MainNav
                        onClickBrandLogo={() => Navigator.goToDashboardHome(this.props.history)}
                    />
                    <div className="container main-container">
                        <LoadingMainContent />
                    </div>
                </div>
            );
        }

        const self = this;
        const _userInfo = this.state.signInStoreState.userInfo;

        const eCommerceEnabled = GlobalConfig.DevOptions && GlobalConfig.DevOptions.ecommerce;
        let canChangeSubscription = eCommerceEnabled && this.state.user_plans && this.state.user_plans.length;

        let subscriptionStatus = 'N/A';
        let subscriptionEndingAt = 'N/A';
        let nextBillDate = 'N/A';
        let planBillingMethod = 'N/A';
        let canCancel = false;
        let isCanceled = false;
        let cancelToolTip = null;
        let cancellationConfirmationText = 'Are you sure you want to cancel your subscription?';
        let existing_plan_id = '';
        let existing_subscription = null;
        const havePlan = this.state.subscription_plan && this.state.subscription_plan.subscription;
        if (havePlan) {
            existing_subscription = this.state.subscription_plan.subscription;
            existing_plan_id = this.state.subscription_plan.plan.id;
            subscriptionStatus = this.state.subscription_plan.subscription.status;
            subscriptionEndingAt = Moment(this.state.subscription_plan.subscription.ending_at).format('MMMM D, YYYY');
            nextBillDate = subscriptionEndingAt;

            let canCancelWPaymentType;
            switch(this.state.subscription_plan.plan.process_type) {
                case Globals.ecommerce.process_types.CC:
                    planBillingMethod = "Credit Card";
                    canCancelWPaymentType = true;
                    break;
                case Globals.ecommerce.process_types.PO:
                    planBillingMethod = "Direct";
                    canCancelWPaymentType = false;
                    canChangeSubscription = false;
                    cancelToolTip = <Tooltip id="cancel-tooltip" placement="right">Cancellations for Direct billing must be processed by <a href="mailto:support@muzzylane.com">contacting Muzzy Lane</a>.</Tooltip>;
                    break;
            }

            switch (this.state.subscription_plan.plan.subscription_status) {
                case Globals.ecommerce.subscription_statuses.trialing:
                case Globals.ecommerce.subscription_statuses.active:
                    cancellationConfirmationText = `Are you sure you want to cancel your subscription? Your next plan bill on ${nextBillDate} will be canceled. Your ${StringUtil.getStingForAccountType(_userInfo.account_type)} account will remain active through ${subscriptionEndingAt} after which it will be reverted to a ${StringUtil.getStingForAccountType(Globals.users.account_types.FREE_V2)} account.`;
                    canCancel = !!canCancelWPaymentType;
                    isCanceled = false;
                    break;
                case Globals.ecommerce.subscription_statuses.canceled:
                    canCancel = false;
                    isCanceled = true;
                    nextBillDate = 'N/A';
                    planBillingMethod = 'N/A';
                    break;
                case Globals.ecommerce.subscription_statuses.past_due:
                case Globals.ecommerce.subscription_statuses.unpaid:
                default:
                    canCancel = false;
                    isCanceled = false;
                    break;

            }
        }

        //TODO: add some mechanism for account deletion

        const registerOrgsEnabled = false; //TODO: temporary disabling for registering organizations, currently admin-only on server
        const anyOrgPlans = (this.state.org_plans && this.state.org_plans.length);

        // TODO: add explanation message that new orgs cannot be created while existing orgs are unpaid or past due
        const anyUnpaidOrgs = some( this.state.owned_org_subscriptions, orgSub => {
            return [Globals.ecommerce.subscription_statuses.unpaid, Globals.ecommerce.subscription_statuses.past_due].indexOf(orgSub.subscription_status) >= 0;
        });

        let canRegisterOrg = true;
        if (!eCommerceEnabled || this.state.showRegisterOrgModal || anyUnpaidOrgs || !_userInfo.email) {
            // don't allow the user to keep registering orgs if:
            //  a. They're in the middle of registring one
            //  b. They already have an unpaid one.
            //  c. They don't have an email
            canRegisterOrg = false;
        }

        // disable editing user info if user.registerd is false
        // assumes that user.registered_idp is true, since user is currently logged in
        // assert that info is controlled via org IDP
        const disableUserInfoEdit = !_userInfo.registered;
        const disabledMessage = disableUserInfoEdit ? 'This information is controlled by your organization' : null;

        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardHome(this.props.history)}
                />
                <div className="container main-container">
                    <SubNav menuClasses= "d-inline-block d-sm-none">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                Account
                            </div>
                            <div className="view-description">
                                Settings
                            </div>
                        </div>
                    </SubNav>
                    <Row className="main-content-nav">
                        <div className="col-12 main-content user-profile">
                            <AccountInfoEdit
                                className="margin-bottom-xl"
                                disabled={disableUserInfoEdit}
                                buttonTitle={disabledMessage}
                            />
                            <AccountSettingsEdit
                                className="margin-bottom-xl"
                            />
                            <Row>
                                <h2 className="col-12">Account License</h2>
                                <div className="col-12">
                                    <hr />
                                </div>
                                <div className="col-12">
                                    <ErrorBox className="margin-bottom-md" error={this.state.subscriptionError} />
                                </div>
                                <div className="col-12 margin-bottom-md">
                                    <label className="label-form" htmlFor="user-account-type">license</label>
                                    <div id="user-account-type">{StringUtil.getStingForAccountType(_userInfo.account_type)}</div>
                                </div>
                                {(havePlan) &&
                                    <div className="col-12 margin-bottom-md">
                                        <label className="label-form" htmlFor="user-account-status">license status</label>
                                        <div id="user-account-status">{StringUtil.getStringForSubscriptionStatus(subscriptionStatus)}</div>
                                    </div>
                                }
                                {(havePlan) &&
                                    <div className="col-12 margin-bottom-md">
                                        <label className="label-form" htmlFor="user-billing-method">billing method</label>
                                        <div id="user-billing-method">{planBillingMethod}</div>
                                    </div>
                                }
                                {(havePlan) &&
                                    <div className="col-12 margin-bottom-md">
                                        <label className="label-form" htmlFor="user-next-bill">subscription active through</label>
                                        <div id="user-next-bill">{subscriptionEndingAt}</div>
                                    </div>
                                }
                                {(havePlan) &&
                                    <div className="col-12 margin-bottom-md">
                                        <label className="label-form" htmlFor="user-next-bill">next billing date</label>
                                        <div id="user-next-bill">{nextBillDate}</div>
                                    </div>
                                }
                                <div className="col-12">
                                    <Row>
                                        {(!!canChangeSubscription) &&
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Link className="link-plain btn btn-primary margin-bottom-md" to="/settings/subscription">upgrade</Link>
                                            </div>
                                         }
                                        {(!!existing_plan_id) &&
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Button className="margin-bottom-md margin-right-sm" variant='warning' disabled={!canCancel} onClick={this.showModal.bind(this, 'showCancelSubscriptionModal')}>cancel subscription</Button>
                                                {cancelToolTip}
                                            </div>
                                        }
                                    </Row>
                                </div>
                            </Row>
                            {(registerOrgsEnabled || this.state.owned_org_subscriptions.length > 0) &&
                                <div className="settings-organization-controls margin-bottom-xl">
                                    <h2>Organizations</h2>
                                    <hr/>
                                    {(this.state.owned_org_subscriptions.length > 0) &&
                                        <SortableTable2
                                            classNameTable="margin-bottom-15 font-size-md"
                                            hideSearch
                                            showTotal={false}
                                            uniqueRowKey="org_id"
                                            rows={this.state.owned_org_subscriptions}
                                            defaultSort={{ key:'org_display_name', type:'string', asc: true }}
                                            columns={[
                                                {
                                                    displayName: 'Organization',
                                                    key: 'org_display_name',
                                                    type: 'string'
                                                },
                                                {
                                                    displayName: 'Email',
                                                    key: 'org_email',
                                                    type: 'string'
                                                },
                                                {
                                                    displayName: 'Verified',
                                                    key: 'org_verified_display',
                                                    type: 'string'
                                                },
                                                {
                                                    displayName: 'Subscription Status',
                                                    key: 'subscription_status',
                                                    type: 'string'
                                                },
                                                {
                                                    displayName: 'Link',
                                                    key: 'org_id',
                                                    type: 'int'
                                                }

                                            ]}
                                            displayColumnCallbacks={{
                                                'subscription_status': StringUtil.getStringForSubscriptionStatus,
                                                'org_id': (orgId) => {
                                                    const orgSub = find(self.state.owned_org_subscriptions, { org_id: orgId });
                                                    if (orgSub.org_verified) {
                                                        return <Link to={Navigator.paths.dashboard_author_channel_view(orgId)}>Goto</Link>;
                                                    }
                                                    else {
                                                        return null;
                                                    }
                                                }
                                            }}
                                        />
                                    }

                                    {(eCommerceEnabled && registerOrgsEnabled) &&
                                        (eCommerceEnabled && anyOrgPlans) ?
                                            <div>
                                                <button className="btn btn-primary" disabled={!canRegisterOrg} onClick={this.openRegisterOrgPanel}>create new organization</button>
                                                {   anyUnpaidOrgs ?
                                                    <WarningBox className="font-size-md">Cannot create new organizations when existing organizations are past due or unpaid.</WarningBox>
                                                    :
                                                    null
                                                }
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            }
                        </div>
                    </Row>
                </div>

                {/*this.state.modalState.subscriptionSettings && this.renderSubscriptionSettingsModal()*/}
                {this.state.showRegisterOrgModal && this.renderRegisterOrgModal()}
                {/*this.state.modalState.orgSubscriptionSettings && this.renderOrgSubscriptionSettingsModal()*/}
                {/*(this.state.showDeleteAccountModal) &&
                    <ConfirmModal
                        show
                        modalTitle="Delete Account"
                        text="Are you sure you want to delete your account?"
                        buttonText="delete"
                        closeHandler={this.hideModal.bind(this, "showDeleteAccountModal")}
                        confirmHandler={this.handleDeleteAccount}
                    />
                */}
                {(this.state.showCancelSubscriptionModal) &&
                    <ConfirmModal
                        show
                        modalTitle="Cancel Subscription"
                        text={cancellationConfirmationText}
                        buttonText="Cancel Subscription"
                        closeHandler={this.hideModal.bind(this, 'showCancelSubscriptionModal')}
                        confirmHandler={this.handleCancelSubscriptionPromise}
                    />
                }
            </div>
        );
    } // render
}

AccountSettings.propTypes = propTypes;
AccountSettings.defaultProps = defaultProps;

export default withRouter(AccountSettings);